
import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Divider, Input, Select, Space, Table, Typography } from 'antd'
import { buscar_cantidad_aspirantes } from '../../functions/arreglos'
import useReporteGeneral from '../../hooks/adminexamen/useReporteGeneral'
import useAspirantesInscritos from '../../hooks/adminexamen/useAspirantesInscritos'
import { carreras } from '../../data/datos'


const { Option } = Select

const AspirantesInscritos = () => {



    const { aspirantesInscritos, columns, loading, buscarInscrito, setBuscarInscrito,
        ciclo, setCiclo, ciclosExamen } = useReporteGeneral( 0 )
    const { generarReporteInscritos, carreraSeleccionada, setCarreraSeleccionada } = useAspirantesInscritos()

    let columnas_que_no_quiero = [ 'Expresión oral y escrita', 'Matemáticas ciencias', 'Matemáticas EA', 'Inglés', 'Acciones', 'Inscribir' ]

    // aquí sólo traigo las columnas que no están en el arreglo "columnas_que_no_quiero"
    const columnas_filtradas = columns.filter( a => !columnas_que_no_quiero.includes( a.title ) )


    // cantidad
    var cantidad_aspirantes = buscar_cantidad_aspirantes( aspirantesInscritos )


    const { Title } = Typography;

    return (
        <>
        <Title level={3}>Generar reporte de aspirantes inscritos</Title>

        <Space direction='vertical'>
            <Select defaultValue={ carreraSeleccionada } onChange={ setCarreraSeleccionada } style={{ width: 400 }}>
                { carreras.map(( e, i ) =>
                    <Option key={ i } value={ e.id }>{ e.nom_carrera }</Option>
                )}
            </Select>

            <Button type="link" onClick={ generarReporteInscritos }>
                Generar reporte
            </Button>
        </Space>


        <Divider/>


        <Title level={3}>Lista de aspirantes inscritos</Title>

        <Select
            size="large"
            style={{
                width: 200,
                margin: '25px 0',
            }}
            onChange={ setCiclo }
            defaultValue={ ciclo }
        >
            <Option value='todos'>
                Mostrar todos
            </Option>
            { ciclosExamen.map((e, i) =>(
                <Option key={ i } value={ e.ciclo_examen }>
                    { e.ciclo_examen }
                </Option>
            )) }
        </Select>

        <Table
            loading={ loading }
            columns={ columnas_filtradas }
            rowKey="pk_aspirante"
            title = { () => (
                <>
                <h1>{ cantidad_aspirantes }</h1>
                <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setBuscarInscrito( e.target.value )  } value={ buscarInscrito } prefix={ <SearchOutlined /> }/>
                </>
            )}
            showSorterTooltip={ false }
            dataSource={ aspirantesInscritos }
        />
        </>
    )
}

export default AspirantesInscritos;
